import React, {Component} from 'react';
import styled from 'styled-components'
import {StyledButton, StyledButtonRed} from "./Buttons";
import {ACCEPTED, WAITING_FOR_DECISION} from "../utils/employeeStatus";

const EmployeeItemDiv = styled.div`
width: 80%;
border: ${props => props.active ? "2px solid #70A3F1" : "2px solid #333333"};
background-color: ${props => props.active ? "#70A3F1" : "transparent"};
color: ${props => props.active ? "#ffffff" : "#333333"};
border-radius: 20px;
margin: 2rem auto;
display: block;
box-sizing: border-box;
height: 10rem;
position: relative;
`

class EmployeeListItem extends Component {
    render() {
        return (
            <EmployeeItemDiv>
                <h2>{this.props.user.firstN} {this.props.user.lastN}</h2>
                <h4>{this.props.user.email}</h4>
                {this.props.status === ACCEPTED ?
                    <div>
                        <StyledButtonRed onClick={this.props.fireFn}>Kirugas</StyledButtonRed>
                    </div>
                    :
                    null
                }
                {this.props.status === WAITING_FOR_DECISION ?
                    <div>
                        <StyledButton onClick={this.props.acceptFn}>Elfogadas</StyledButton>
                        <StyledButtonRed onClick={this.props.declineFn}>Elutasitas</StyledButtonRed>

                    </div>
                    :
                    null
                }
            </EmployeeItemDiv>
        );
    }
}

export default EmployeeListItem;